<template>
  <div id="search_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Search Options</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">From</label>
                        <div class="col-md-8">
                          <input
                            v-model="formParam.columnFilters.start_date"
                            type="date"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">To</label>
                        <div class="col-md-8">
                          <input
                            v-model="formParam.columnFilters.end_date"
                            type="date"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Marketplace</label
                        >
                        <div class="col-md-8">
                          <multiselect
                            v-model="formParam.mpIds"
                            placeholder="Marketplace"
                            :options="dataListMarketplace"
                            :multiple="true"
                            :taggable="true"
                          ></multiselect>
                          <!-- <select
                            v-model="formParam.columnFilters.mp_id"
                            class="form-control"
                          >
                            <option :value="''">All</option>
                            <template v-if="dataListMarketplace.length">
                              <option
                                :value="marketplace"
                                v-for="(marketplace,
                                idx) in dataListMarketplace"
                                :key="idx"
                                >{{ marketplace | capitalising }}</option
                              >
                            </template>
                          </select> -->
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">Status</label>
                        <div class="col-md-8">
                          <select
                            v-model="formParam.columnFilters.status_value"
                            class="form-control"
                          >
                            <option :value="''">All</option>
                            <template v-if="dataListMonitoringStatus.length">
                              <option
                                :value="row.id"
                                v-for="(row, idx) in dataListMonitoringStatus"
                                :key="idx"
                                >{{ row.label }}</option
                              >
                            </template>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">Brand</label>
                        <div class="col-md-8">
                          <multiselect
                            v-model="selectedContact"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :placeholder="'Type to search Brand...'"
                            :multiple="true"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="contactOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFind"
                            :show-labels="false"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span
                                  class="custom__remove"
                                  @click="remove(option)"
                                  >❌</span
                                >
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedContact.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">Product</label>
                        <div class="col-md-8">
                          <multiselect
                            v-if="selectedContact.length"
                            v-model="selectedProduct"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :placeholder="'Type to search Product...'"
                            :multiple="true"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="productOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFindProduct"
                            :show-labels="false"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <span class="custom__tag">
                                <span>{{ option.name }}</span>
                                <span
                                  class="custom__remove"
                                  @click="remove(option)"
                                  >❌</span
                                >
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedProduct.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">Rating</label>
                        <div class="col-md-8">
                          <select
                            v-model="formParam.columnFilters.rating"
                            class="form-control"
                          >
                            <option value>⭐ All</option>
                            <option :value="5">⭐ 5</option>
                            <option :value="4">⭐ 4 ke atas</option>
                            <option :value="3">⭐ 3 ke atas</option>
                            <option :value="2">⭐ 2 ke atas</option>
                            <option :value="1">⭐ 1 ke atas</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Cek Username Toko</label
                        >
                        <div class="col-md-8">
                          <select
                            v-model="formParam.columnFilters.is_store_name"
                            class="form-control"
                            @change="handleIsStoreName"
                          >
                            <option value>All</option>
                            <option value="ada">Sudah Ada</option>
                            <option value="tidak">Belum Ada</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Username Toko</label
                        >
                        <div class="col-md-8">
                          <input
                            v-model="formParam.columnFilters.store_name"
                            type="text"
                            class="form-control"
                            :disabled="
                              formParam.columnFilters.is_store_name == 'tidak'
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Produk Toko</label
                        >
                        <div class="col-md-8">
                          <input
                            v-model="formParam.columnFilters.product_name"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Harga Minimal</label
                        >
                        <div class="col-md-8">
                          <input
                            v-model="
                              formParam.columnFilters.product_price_start
                            "
                            type="number"
                            min="0"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4"
                          >Harga Maksimal</label
                        >
                        <div class="col-md-8">
                          <input
                            v-model="formParam.columnFilters.product_price_end"
                            type="number"
                            min="0"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label col-md-2">Link</label>
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        v-model="formParam.columnFilters.product_url"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending == false">
                    <!-- {{isSending}} -->
                    <button
                      @click.prevent="clearSearch"
                      type="button"
                      class="btn btn-md btn-light"
                    >
                      <i class="fa fa-trash"></i> Clear Filter
                    </button>
                    <button
                      @click.prevent="applySearch"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-search"></i> Search
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      selectedProduct: [],
      productOptions: [],
      productListParam: {
        brand_id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isSending: false,
      dataListMonitoringStatus: [],
      dataListMarketplace: [],
      formParam: {
        columnFilters: {
          start_date: "",
          end_date: "",
          product_id: "",
          brand_id: "",
          mp_id: "",
          status_value: "",
          sr_detail_id: "",
          is_store_name: "",
          store_name: "",
          product_name: "",
          product_price_start: "",
          product_price_end: "",
          product_url: "",
          product_price_start: "",
          product_price_end: ""
        },
        page: 1,
        perPage: 20,
        more_search: false,
        mpIds: []
      },
      isLoading: false
    };
  },
  watch: {
    selectedProduct: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedProduct = val;
        }
        if (val.length == 1) {
          this.formParam.columnFilters.product_id = val[0].id;
          // this.searchData();
        } else {
          this.formParam.columnFilters.product_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
          // this.asyncFindProduct()
        }
        if (val.length == 1) {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formParam.columnFilters.brand_id = val[0].id;
          this.asyncFindProduct();
          // this.searchData();
        } else {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formParam.columnFilters.brand_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            that.formParam = that.formParamSt;
            that.getMonitoringListStatus();
            that.getMarketplaceList();
            that.asyncFind();
            // that.asyncFindProduct();
            // console.log("")
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamSt() {
      return this.$store.state.monitoring.formParamSt;
    },
    isShowForm() {
      return this.$store.state.monitoring.isShowForm;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    async clearSearch() {
      let sr_detail_id = this.$route.query.sr_detail_id;
      if (typeof sr_detail_id != "undefined" && sr_detail_id != "") {
        var elem = this.$refs.dismisModal;
        elem.click();
        window.location.href = this.baseUrl + "/monitoring/links/list";
        return false;
      }
      this.selectedContact = [];
      let newFormParam = {
        columnFilters: {
          start_date: "",
          end_date: "",
          product_id: "",
          brand_id: "",
          mp_id: "",
          status_value: "",
          sr_detail_id: "",
          rating: "",
          is_store_name: "",
          store_name: "",
          product_name: "",
          product_price_start: "",
          product_price_end: "",
          product_url: "",
          product_price_start: "",
          product_price_end: ""
        },
        page: 1,
        perPage: 20,
        more_search: false,
        mpIds: []
      };
      await this.$store.dispatch("monitoring/actFormParamStD", newFormParam);
      // this.searchData();
      // console.log("newFormParam", newFormParam);
      var elem = this.$refs.dismisModal;
      elem.click();
    },
    async applySearch() {
      let newFormParam = this.formParam;
      newFormParam.more_search = true;
      await this.$store.dispatch("monitoring/actFormParamStD", newFormParam);
      this.searchData();
      // console.log("newFormParam", newFormParam);
      var elem = this.$refs.dismisModal;
      elem.click();
    },
    asyncFindProduct(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.productListParam.name = query;
      // console.log("selectedContact", this.selectedContact);
      this.productListParam.brand_id = this.selectedContact[0].id;
      this.$store
        .dispatch("brandProduct/list", this.productListParam)
        .then(response => {
          this.isLoading = false;
          this.productOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch(this.$route.name.includes('agent')? 'brand/listAgent': 'brand/list', this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    handleIsStoreName() {
      if (this.formParam.columnFilters.is_store_name == "tidak") {
        this.formParam.columnFilters.store_name = "";
      }
    },
    getMarketplaceList() {
      this.$store.dispatch("monitoring/getMarketplaceList").then(respons => {
        this.dataListMarketplace = respons.data;
      });
    },
    getMonitoringListStatus() {
      this.$store
        .dispatch("monitoring/getMonitoringListStatus")
        .then(respons => {
          this.dataListMonitoringStatus = respons.data;
        });
    },
    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          let action = "create";
          if (this.formParam.id != "") {
            action = "update";
          }
          await this.$store
            .dispatch("brand/" + action, this.formParam)
            .then(response => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  id: "",
                  name: "",
                  description: ""
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
                this.formParam = {
                  id: "",
                  name: "",
                  description: ""
                };
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/links/formDuplicate.vue